import { Button, Icon, Input, message, Modal } from 'antd';
import moment from 'moment';
import React, { Component, Fragment } from 'react'
import { withTranslation } from 'react-i18next';
import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import * as Func from '../../../../../../helpers/functions';
import * as HMS from '../../../../common/component/Index';
import Wrapper from '../../../../common/component/Wrapper';

const defaultState = {
    validation: {},
    bookData: {
        id: undefined,
        bookDateFrom: undefined,
        bookDateTo: undefined,
        markupValue: undefined,
        status: false
    },
    hotelData: {
        hotel: {
            totalRateConfiged: 0
        }
    },
    isShowBookDateHistory: false
};

const ListCols = ['bookDateFrom', 'bookDateTo', 'markupValue']
const ModelFields = ['bookDateFrom', 'bookDateTo', 'markupValue']

class BookDate extends Component {
    constructor(props) {
        super()
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                bookDateFrom: {
                    width: 250,
                    render: (value, record) => value && moment(moment.utc(value).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                bookDateTo: {
                    width: 250,
                    key: 'bookDateTo',
                    render: (value, record) => value && moment(moment.utc(value).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                markupValue: {
                    render: (value, record) => {
                        if (value) {
                            if (this.props.isPercent) {
                                return value + '%'
                            } else {
                                return Func.formatMoney(value) + ' đ'
                            }
                        }
                    }
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record, index) => this.renderEditComponent(record, index),
                }
            },
        }
    }

    render() {

        const { t, bookDates, inActiveBookDates, disabled = false } = this.props
        const { validation, bookData, modelItem, titleItemTable, componentTable } = this.state
        return (
            <Fragment>
                <Wrapper className="col-md-6">
                    <HMS.FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        messageBelowInput={true}
                        labelTitle={t(`item.markupBundle.bookDates`)}
                    >
                        <Wrapper className="row">
                            <Wrapper className="col-md-9">
                                <HMS.DatePickerComponent className={`form-control applyDates w100-percent`}
                                    disabledDate={this.disabledPublishDate}
                                    hmsComponent={`RangePicker`} format={DATE_TIME_FORMAT.SHORT_DATE}
                                    showTime={{ format: DATE_TIME_FORMAT.SHORT_DATE }}
                                    style={{ padding: 0, border: 0 }}
                                    onChange={(data) => this.onSelectDateRange(data, 'bookDateFrom', 'bookDateTo')} name={`applyDates`}
                                    placeholder={[t('placeHolderForm.startDate'), t('placeHolderForm.endDate')]}
                                    value={[bookData.bookDateFrom, bookData.bookDateTo]}
                                    disabled={disabled}
                                />
                            </Wrapper>
                            <Wrapper className="col-md-3">
                                <Input placeholder={t('item.markupBundle.placeHolderForm.markupValue')} type={`text`}
                                    className={`form-control`}
                                    disabled={disabled}
                                    name={`markupValue_bookDate`} onChange={(e) => this.onChangeBookDate('markupValue', e.target.value.trimLeft())}
                                    value={Func.checkUndefine(bookData.markupValue)} />
                            </Wrapper>
                        </Wrapper>
                    </HMS.FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-3">
                    <Button type="primary" disabled={disabled} onClick={this.addItem}>Thêm</Button>
                </Wrapper>
                <Wrapper className="col-md-12">
                    <HMS.ListComponent
                        tableKey="agents-list"
                        bordered
                        classChildren="p-0" classParent="m-0"
                        rowKey={(record, index) => index}
                        loading={false}
                        dataSource={Func.getDataSource(bookDates || [], modelItem)}
                        columns={Func.columnsTable({
                            titleTable: titleItemTable,
                            component: componentTable,
                            itemName: 'markupBundle'
                        })}
                        pagination={{}}
                        componentTableList={{}}
                        onColumnVisibleChange={this.onColumnVisibleChange}
                    />
                </Wrapper>
                <Wrapper className="col-md-12 text-right">
                    {
                        inActiveBookDates.length > 0 &&
                        <Fragment>
                            <div style={{ marginBottom: 10 }}><a rel="noopener noreferrer" onClick={this.onShowBookDateHistory}>
                                {!this.state.isShowBookDateHistory ? 'Hiển thị lịch sử đã xóa' : 'Ẩn lịch sử đã xóa'}
                            </a></div>
                        </Fragment>
                    }
                    {this.state.isShowBookDateHistory &&
                        <Fragment>
                            {inActiveBookDates.map(item => (
                                <p>
                                    {moment(moment.utc(item.bookDateFrom).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)} đến ngày
                                    {' ' + moment(moment.utc(item.bookDateTo).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)} giá trị
                                    {' ' + (this.props.isPercent ? item.markupValue + '% ' : Func.formatMoney(item.markupValue) + 'đ ')}
                                    <button type="button" className='ant-btn btn btn-sm btn-primary ml-2' onClick={() => this.onRevertBookDate(item)}><span>Revert</span></button>
                                </p>
                            ))}
                        </Fragment>
                    }
                </Wrapper>
            </Fragment>
        )
    }

    addItem = () => {
        let isValid = true
        Object.keys(this.state.bookData).forEach(key => {
            if (key !== 'id' && key !== 'status' && !this.state.bookData[key] && isValid) {
                isValid = false
                return message.error('Vui lòng nhập đầy đủ thông tin bookdate trước khi thêm!');
            }
        })
        if (isValid) {
            this.props.addBookDate({ ...this.state.bookData, status: true })
            this.setState({
                bookData: {
                    bookDateFrom: undefined,
                    bookDateTo: undefined,
                    markupValue: undefined
                }
            })
        }

    }

    onSelectDateRange = (data, fieldStartDate, fieldEndDate) => {
        this.onChangeBookDate(fieldStartDate, data.fullValue[0]);
        this.onChangeBookDate(fieldEndDate, data.fullValue[1]);
    }

    onChangeBookDate = (fieldName, value) => {
        const bookData = this.state.bookData;
        bookData[fieldName] = value;
        this.setState({ bookData });
    };

    onRevertBookDate = (value) => {
        this.props.revertBookDate(value.id)
    };
    onShowBookDateHistory = () => {
        let isShow = !this.state.isShowBookDateHistory;
        this.setState({ isShowBookDateHistory: isShow });
    }

    disabledPublishDate = (current) => {
        return current && current <= moment().add(-1, 'day');
    }

    renderEditComponent(item, index) {
        const { t, disabled = false } = this.props;
        const removeBookDate = () => {
            return this.props.onDelete && this.props.onDelete(index, disabled)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.category.title`)),
                content: item.markupValue,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeBookDate,
            });
        };
        return (
            <Fragment>
                {<Icon type="delete" className="fs20 cursorPointer" onClick={onRemove} />}
            </Fragment>
        )
    }
}

export default withTranslation()(BookDate)